module.exports = __webpack_public_path__ + "static/media/23whostosay.d7d83929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/23whostosay.png
// module id = 118
// module chunks = 0